// extracted by mini-css-extract-plugin
export var skillsList = "SkillsList-module--skillsList--xXuKw";